module.exports = __webpack_public_path__ + "img/dlt_kind_4.b04260ef.svg";